import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import washingtouch from "../image/touchm.png";
import washingMachine1 from "../image/f1.png";
import washingMachine3 from "../image/f3.png";

const Banner = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  const items = [
    {
      id: 1,
      title: "Washing Machines",
      img: washingtouch,
      link: "/luxury-appliances/1",
    },
    {
      id: 3,
      title: "Refrigerator",
      img: washingMachine3,
      link: "/luxury-appliances/3",
    },
    {
      id: 5,
      title: "Dishwasher",
      img: washingMachine1,
      link: "/luxury-appliances/5",
    },
  ];

  return (
    <div className="bg-gray">
      <div className="w-full h-[1px] bg-[#800000]"></div>

      <div className="pb-5 px-4 md:px-10 mt-5 font-roboto relative">
        <h1 className="font-bold text-2xl uppercase text-center tracking-wider">
          Luxury Appliances
        </h1>

        {/* Arrows (mobile only) */}
        <div className="sm:hidden flex justify-between items-center mt- mb-2 px-2">
          <button
            onClick={() => scroll("left")}
            className="bg-[#dffff] p-2 rounded-full text-teal-800 shadow-md"
          >
            <FaChevronLeft />
          </button>
          <button
            onClick={() => scroll("right")}
            className="bg-[#dffff] p-2 rounded-full text-teal-800 shadow-md"
          >
            <FaChevronRight />
          </button>
        </div>

        {/* Scrollable Cards */}
        <div
          ref={scrollRef}
          className="mt-4 sm:grid sm:grid-cols-2 md:grid-cols-3 gap-6 overflow-x-auto sm:overflow-visible flex sm:flex-none space-x-4 sm:space-x-0 scroll-smooth snap-x snap-mandatory pb-4"
        >
          {items.map((item) => (
            <Link
              key={item.id}
              to={item.link}
              className="min-w-[260px] sm:min-w-0 bg-white p-4 shadow-xl rounded-lg flex flex-col items-center hover:scale-[1.02] transition duration-200 ease-in-out snap-start"
            >
              <h1 className="font-black text-base sm:text-lg md:text-xl underline text-[#800000] uppercase text-center">
                {item.title}
              </h1>
              <img
                src={item.img}
                alt={item.title}
                className="w-full max-w-[350px] mt-3 rounded-lg object-contain"
              />
             <div className="flex items-center w-full">
        <button className="bg-white text-black px-4 py-2 border border-black  rounded-md flex-1 font-semibold hover:bg-[#800000] hover:text-white">
          Explore
        </button>
        
      </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;
